import { Flex } from '../ui';
import { cn } from '@/src/helpers';

type SignLeftSideProps = {
  children: React.ReactNode;
  className?: string;
};

export const SignLeftSide = ({ children, className }: SignLeftSideProps) => {
  return (
    <Flex className={cn('hidden lg:flex lg:w-1/2', className)}>{children}</Flex>
  );
};
